import { createFileRoute } from '@tanstack/react-router'
import { JobRoleEditorPage } from '@/features/job-roles/editor'

export const Route = createFileRoute('/job-roles_/new')({
  component: JobRoleEditorPage,
})
